var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLindaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 339.77332,
    height: 255.66667,
    viewBox: "0 0 339.77332 255.66667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,255.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.7461,987.57 H 62.1484 V 790.789 H 182.141 v -17.41 H 41.7461 V 987.57",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 199.363,928.18 h 18.899 V 773.379 h -18.899 z m 0,59.39 h 18.899 v -30.293 h -18.899 v 30.293",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 251.582,928.18 h 18.906 v -26.7 h 0.598 c 6.902,18.59 27.598,31.2 49.5,31.2 43.496,0 56.699,-22.801 56.699,-59.7 v -99.601 h -18.906 v 96.59 c 0,26.703 -8.699,46.812 -39.297,46.812 -30,0 -47.996,-22.801 -48.594,-53.101 V 773.379 H 251.582 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 473.457,784.781 c 40.195,0 54.297,33.91 54.297,66 0,32.098 -14.102,66 -54.297,66 -35.996,0 -50.691,-33.902 -50.691,-66 0,-32.09 14.695,-66 50.691,-66 z m 73.191,-11.402 h -17.39 v 29.402 h -0.606 c -8.093,-20.101 -32.695,-33.902 -55.195,-33.902 -47.102,0 -69.602,38.101 -69.602,81.902 0,43.789 22.5,81.899 69.602,81.899 23.098,0 45.598,-11.7 53.699,-33.91 h 0.598 v 88.8 h 18.894 V 773.379",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 679.883,857.98 h -0.598 c -2.398,-4.5 -10.801,-6 -15.894,-6.898 -32.102,-5.703 -72.004,-5.402 -72.004,-35.703 0,-18.899 16.804,-30.598 34.504,-30.598 28.797,0 54.297,18.301 53.992,48.598 z m -100.789,22.801 c 1.797,36.289 27.293,51.899 62.691,51.899 27.297,0 57.004,-8.399 57.004,-49.801 V 800.68 c 0,-7.2 3.594,-11.399 11.094,-11.399 2.097,0 4.504,0.61 6.008,1.199 v -15.898 c -4.211,-0.891 -7.207,-1.203 -12.305,-1.203 -19.199,0 -22.199,10.801 -22.199,27 h -0.606 c -13.191,-20.09 -26.699,-31.5 -56.394,-31.5 -28.496,0 -51.899,14.101 -51.899,45.301 0,43.5 42.297,45 83.098,49.8 15.598,1.801 24.297,3.899 24.297,20.989 0,25.5 -18.301,31.812 -40.496,31.812 -23.403,0 -40.793,-10.801 -41.399,-36 h -18.894",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 980.188,922.777 c -7.2,32.996 -34.504,51.895 -65.696,51.895 -56.699,0 -80.703,-47.395 -80.703,-94.192 0,-46.8 24.004,-94.199 80.703,-94.199 39.59,0 64.793,30.598 68.692,68.699 h 20.396 c -5.697,-52.5 -38.99,-86.101 -89.088,-86.101 -67.5,0 -101.101,53.101 -101.101,111.601 0,58.5 33.601,111.594 101.101,111.594 40.496,0 80.696,-24.297 86.098,-69.297 h -20.402",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1029.12,928.18 h 17.4 v -36.301 h 0.6 c 9.6,24.902 30.6,39.601 58.5,38.398 v -18.898 c -34.2,1.801 -57.6,-23.399 -57.6,-55.5 v -82.5 h -18.9 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1122.98,928.18 h 18.9 v -26.7 h 0.6 c 6.9,18.59 27.6,31.2 49.5,31.2 43.5,0 56.7,-22.801 56.7,-59.7 v -99.601 h -18.9 v 96.59 c 0,26.703 -8.71,46.812 -39.3,46.812 -30,0 -48,-22.801 -48.6,-53.101 v -90.301 h -18.9 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1282.4,928.18 h 18.9 V 773.379 h -18.9 z m 0,59.39 h 18.9 v -30.293 h -18.9 v 30.293",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1444.42,879.57 c -5.09,23.11 -19.2,37.211 -43.79,37.211 -36.3,0 -54.3,-33.011 -54.3,-66 0,-33 18,-66 54.3,-66 23.39,0 42.59,18.301 45,44.098 h 18.89 c -5.1,-37.199 -29.4,-60 -63.89,-60 -47.41,0 -73.21,37.5 -73.21,81.902 0,44.399 25.8,81.899 73.21,81.899 32.99,0 58.49,-17.711 62.69,-53.11 h -18.9",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1579.42,987.57 h 20.4 V 773.379 h -20.4 V 987.57",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1637.34,928.18 h 18.91 v -26.7 h 0.6 c 6.9,18.59 27.59,31.2 49.5,31.2 43.49,0 56.7,-22.801 56.7,-59.7 v -99.601 h -18.91 v 96.59 c 0,26.703 -8.7,46.812 -39.3,46.812 -30,0 -47.99,-22.801 -48.59,-53.101 v -90.301 h -18.91 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1888.38,882.879 c -0.9,23.391 -18.9,33.902 -40.5,33.902 -16.8,0 -36.59,-6.601 -36.59,-26.699 0,-16.801 19.2,-22.801 32.09,-26.102 l 25.2,-5.699 c 21.61,-3.301 44.1,-15.902 44.1,-42.902 0,-33.598 -33.3,-46.5 -62.09,-46.5 -36.01,0 -60.61,16.801 -63.61,54.601 h 18.91 c 1.49,-25.5 20.39,-38.699 45.59,-38.699 17.7,0 42.3,7.801 42.3,29.399 0,18 -16.8,24 -33.9,28.199 l -24.29,5.402 c -24.6,6.598 -43.21,15 -43.21,41.391 0,31.508 30.9,43.508 58.21,43.508 30.89,0 55.49,-16.2 56.7,-49.801 h -18.91",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1966.91,928.18 h 31.5 v -15.899 h -31.5 V 807.879 c 0,-12.297 1.8,-19.5 15.31,-20.399 5.4,0 10.8,0.301 16.19,0.899 V 772.18 c -5.7,0 -11.1,-0.59 -16.8,-0.59 -25.19,0 -33.9,8.39 -33.59,34.789 v 105.902 h -27 v 15.899 h 27 v 46.492 h 18.89 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2020.44,928.18 h 18.9 V 773.379 h -18.9 z m 0,59.39 h 18.9 v -30.293 h -18.9 v 30.293",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2103.59,928.18 h 31.5 v -15.899 h -31.5 V 807.879 c 0,-12.297 1.8,-19.5 15.31,-20.399 5.4,0 10.8,0.301 16.19,0.899 V 772.18 c -5.7,0 -11.1,-0.59 -16.8,-0.59 -25.19,0 -33.9,8.39 -33.59,34.789 v 105.902 h -27 v 15.899 h 27 v 46.492 h 18.89 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2282.51,773.379 h -17.4 v 27.902 h -0.61 c -9.89,-20.699 -30.29,-32.402 -53.39,-32.402 -39,0 -54.3,22.801 -54.3,58.801 v 100.5 h 18.9 V 827.379 c 0.9,-27.891 11.4,-42.598 41.4,-42.598 32.4,0 46.49,30.598 46.49,62.098 v 81.301 h 18.91 V 773.379",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2346.94,928.18 h 31.5 v -15.899 h -31.5 V 807.879 c 0,-12.297 1.8,-19.5 15.31,-20.399 5.4,0 10.8,0.301 16.19,0.899 V 772.18 c -5.7,0 -11.1,-0.59 -16.8,-0.59 -25.19,0 -33.9,8.39 -33.59,34.789 v 105.902 h -27.01 v 15.899 h 27.01 v 46.492 h 18.89 V 928.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2507.44,861.582 c -0.9,28.5 -18.6,55.199 -49.2,55.199 -30.9,0 -48,-27 -50.99,-55.199 z M 2407.25,845.68 c 0.29,-27.598 14.69,-60.899 50.99,-60.899 27.6,0 42.6,16.199 48.6,39.598 h 18.9 c -8.1,-35.098 -28.5,-55.5 -67.5,-55.5 -49.2,0 -69.9,37.801 -69.9,81.902 0,40.801 20.7,81.899 69.9,81.899 49.8,0 69.6,-43.508 68.1,-87 h -119.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.8984,592.281 H 45.3008 V 453.379 H 26.4063 V 592.281 H 0 v 15.899 h 26.4063 v 14.101 c -0.3047,26.699 7.1953,45.289 37.4921,45.289 5.3985,0 9.8985,-0.3 15.9063,-1.199 V 650.18 c -5.1055,0.902 -9.3086,1.492 -13.8086,1.492 -20.9961,0 -20.3906,-13.203 -20.6953,-30 V 608.18 h 30.5976 v -15.899",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.1211,530.781 c 0,-33 17.9959,-66 54.2969,-66 36.301,0 54.297,33 54.297,66 0,32.989 -17.996,66 -54.297,66 -36.301,0 -54.2969,-33.011 -54.2969,-66 z m 127.4879,0 c 0,-44.402 -25.796,-81.902 -73.191,-81.902 -47.402,0 -73.2032,37.5 -73.2032,81.902 0,44.399 25.8012,81.899 73.2032,81.899 47.395,0 73.191,-37.5 73.191,-81.899",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 252.742,608.18 h 17.403 v -36.301 h 0.597 c 9.602,24.902 30.606,39.601 58.496,38.402 v -18.902 c -34.199,1.801 -57.597,-23.399 -57.597,-55.5 v -82.5 H 252.742 V 608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 454.641,470.789 h 43.496 c 61.492,-0.309 88.191,25.801 88.191,89.691 0,63.899 -26.699,89.989 -88.191,89.7 H 454.641 Z M 434.238,667.57 h 74.09 c 64.504,-1.488 98.402,-36.89 98.402,-107.09 0,-70.199 -33.898,-105.589 -98.402,-107.101 h -74.09 V 667.57",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 646.277,530.781 c 0,-33 18,-66 54.297,-66 36.301,0 54.297,33 54.297,66 0,32.989 -17.996,66 -54.297,66 -36.297,0 -54.297,-33.011 -54.297,-66 z m 127.493,0 c 0,-44.402 -25.801,-81.902 -73.196,-81.902 -47.398,0 -73.203,37.5 -73.203,81.902 0,44.399 25.805,81.899 73.203,81.899 47.395,0 73.196,-37.5 73.196,-81.899",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 779.863,608.18 h 20.098 l 39.602,-132.602 h 0.593 l 37.805,132.602 h 21.297 l 37.793,-132.602 h 0.605 l 39.602,132.602 h 20.097 L 947.559,453.379 h -20.704 l -38.093,130.203 h -0.61 L 850.359,453.379 H 829.656 L 779.863,608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1016.37,608.18 h 18.9 v -26.7 h 0.6 c 6.9,18.59 27.6,31.2 49.5,31.2 43.5,0 56.7,-22.801 56.7,-59.7 v -99.601 h -18.91 v 96.59 c 0,26.703 -8.7,46.812 -39.29,46.812 -30,0 -48,-22.801 -48.6,-53.101 v -90.301 h -18.9 V 608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1274.37,523.879 c -0.9,-44.098 30.89,-57.598 69.89,-57.598 22.5,0 56.7,12.301 56.7,43.5 0,24.301 -24.3,33.899 -44.1,38.699 l -47.7,11.7 c -25.2,6.3 -48.3,18.3 -48.3,51.601 0,21 13.51,60.289 73.8,60.289 42.3,0 79.5,-22.8 79.2,-66.601 h -20.4 c -1.2,32.711 -28.2,49.203 -58.5,49.203 -27.9,0 -53.7,-10.801 -53.7,-42.602 0,-20.09 15,-28.488 32.4,-32.691 l 52.2,-12.899 c 30.3,-8.101 55.5,-21.3 55.5,-56.398 0,-14.703 -6,-61.203 -81.9,-61.203 -50.7,0 -87.9,22.801 -85.5,75 h 20.41",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1431.98,608.18 h 20.11 l 51,-131.989 47.69,131.989 h 18.9 l -67.2,-178.5 c -10.8,-26.09 -17.1,-33.59 -40.79,-33.59 -7.5,0.289 -11.41,0.289 -14.4,1.492 v 15.898 c 4.5,-0.898 8.7,-1.492 12.9,-1.492 16.79,0 20.7,9.903 27,24.293 l 6.6,17.699 -61.81,154.2",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1587.49,608.18 h 18.91 v -26.7 h 0.59 c 6.91,18.59 27.6,31.2 49.5,31.2 43.5,0 56.7,-22.801 56.7,-59.7 v -99.601 h -18.9 v 96.59 c 0,26.703 -8.7,46.812 -39.3,46.812 -30,0 -48,-22.801 -48.59,-53.101 v -90.301 h -18.91 V 608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1809.37,464.781 c 40.19,0 54.29,33.91 54.29,66 0,32.098 -14.1,66 -54.29,66 -36,0 -50.7,-33.902 -50.7,-66 0,-32.09 14.7,-66 50.7,-66 z m 73.19,-11.402 h -17.39 v 29.402 h -0.61 c -8.1,-20.101 -32.69,-33.902 -55.19,-33.902 -47.1,0 -69.6,38.101 -69.6,81.902 0,43.789 22.5,81.899 69.6,81.899 23.09,0 45.59,-11.7 53.7,-33.91 h 0.59 v 88.8 h 18.9 V 453.379",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1916.44,608.18 h 17.4 v -36.301 h 0.59 c 9.6,24.902 30.61,39.601 58.5,38.402 v -18.902 c -34.2,1.801 -57.6,-23.399 -57.6,-55.5 v -82.5 h -18.89 V 608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2016.3,530.781 c 0,-33 18,-66 54.3,-66 36.29,0 54.29,33 54.29,66 0,32.989 -18,66 -54.29,66 -36.3,0 -54.3,-33.011 -54.3,-66 z m 127.49,0 c 0,-44.402 -25.8,-81.902 -73.19,-81.902 -47.41,0 -73.21,37.5 -73.21,81.902 0,44.399 25.8,81.899 73.21,81.899 47.39,0 73.19,-37.5 73.19,-81.899",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2169.92,608.18 h 17.4 v -26.11 h 0.9 c 9.91,18.61 26.1,30.61 50.7,30.61 20.4,0 38.7,-9.899 44.4,-30.301 9.3,20.402 28.8,30.301 49.2,30.301 33.9,0 51.3,-17.711 51.3,-54.301 v -105 h -18.91 v 104.09 c 0,25.5 -9.6,39.312 -36.59,39.312 -32.7,0 -42,-27 -42,-55.801 v -87.601 h -18.9 v 105 c 0.29,21 -8.4,38.402 -32.4,38.402 -32.7,0 -45.9,-24.601 -46.2,-57 v -86.402 h -18.9 V 608.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2529.36,541.582 c -0.9,28.5 -18.61,55.199 -49.2,55.199 -30.9,0 -48,-27 -51,-55.199 z m -100.2,-15.902 c 0.29,-27.602 14.7,-60.899 51,-60.899 27.59,0 42.59,16.199 48.59,39.598 h 18.91 c -8.11,-35.098 -28.51,-55.5 -67.5,-55.5 -49.2,0 -69.91,37.801 -69.91,81.902 0,40.801 20.71,81.899 69.91,81.899 49.79,0 69.6,-43.508 68.09,-87 h -119.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 320.535,270.391 h 9.531 V 208.48 c -0.144,-23.25 10.93,-32.07 29.282,-32.07 18.484,0 29.547,8.82 29.414,32.07 v 61.911 h 9.519 v -64.012 c 0,-20.578 -11.062,-38.09 -38.933,-38.09 -27.746,0 -38.813,17.512 -38.813,38.09 v 64.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 424.219,270.391 h 10.652 l 58.274,-84.59 h 0.273 v 84.59 h 9.531 V 170.379 h -10.652 l -58.274,84.609 h -0.273 v -84.609 h -9.531 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 529.934,270.391 h 9.531 V 170.379 h -9.531 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 555.813,270.391 h 10.222 l 32.488,-89.5 h 0.286 l 32.214,89.5 h 10.09 L 603.992,170.379 H 592.93 l -37.117,100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 657.102,270.391 h 69.05 v -8.121 h -59.531 v -36.129 h 55.75 v -8.129 h -55.75 v -39.5 h 60.234 v -8.133 h -69.753 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 754.602,222.91 h 35.574 c 11.633,0 21.57,7.289 21.57,19.481 0,12.179 -7.273,19.879 -21.57,19.879 h -35.574 z m -9.524,47.481 h 45.801 c 16.531,0 30.398,-7.969 30.398,-26.051 0,-12.602 -6.582,-22.969 -19.468,-25.488 v -0.282 c 13.027,-1.679 16.804,-10.648 17.507,-22.55 0.418,-6.872 0.418,-20.598 4.622,-25.641 h -10.5 c -2.383,3.93 -2.383,11.351 -2.668,15.551 -0.836,14.019 -1.961,29.558 -20.028,28.859 h -36.14 v -44.41 h -9.524 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 849.148,203.301 c -0.418,-20.59 14.426,-26.891 32.637,-26.891 10.512,0 26.477,5.738 26.477,20.309 0,11.34 -11.348,15.82 -20.594,18.07 l -22.27,5.461 c -11.765,2.949 -22.554,8.539 -22.554,24.09 0,9.808 6.304,28.16 34.461,28.16 19.746,0 37.121,-10.648 36.98,-31.102 h -9.527 c -0.559,15.274 -13.164,22.981 -27.317,22.981 -13.027,0 -25.07,-5.051 -25.07,-19.891 0,-9.386 7.004,-13.308 15.129,-15.277 l 24.375,-6.012 c 14.141,-3.789 25.906,-9.949 25.906,-26.34 0,-6.871 -2.801,-28.57 -38.238,-28.57 -23.676,0 -41.035,10.641 -39.926,35.012 h 9.531",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 939.785,270.391 h 9.531 V 170.379 h -9.531 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 965.801,270.391 h 79.289 v -8.121 h -34.88 v -91.891 h -9.53 v 91.891 h -34.879 v 8.121",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1094.99,211.57 -39.36,58.821 h 11.34 l 32.92,-50.7 32.79,50.7 h 11.33 l -39.49,-58.821 v -41.191 h -9.53 v 41.191",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1247.45,176.41 c 26.33,0 37.54,22.129 37.54,43.981 0,21.847 -11.21,43.988 -37.54,43.988 -26.47,0 -37.68,-22.141 -37.68,-43.988 0,-21.852 11.21,-43.981 37.68,-43.981 z m 0,96.09 c 31.38,0 47.06,-24.789 47.06,-52.109 0,-27.313 -15.68,-52.102 -47.06,-52.102 -31.52,0 -47.21,24.789 -47.21,52.102 0,27.32 15.69,52.109 47.21,52.109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1316.15,270.391 h 63.45 v -8.121 h -53.93 v -36.129 h 47.91 v -8.129 h -47.91 v -47.633 h -9.52 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1517.36,240.141 c -3.36,15.41 -16.1,24.238 -30.67,24.238 -26.48,0 -37.69,-22.141 -37.69,-43.988 0,-21.852 11.21,-43.981 37.69,-43.981 18.49,0 30.25,14.289 32.08,32.07 h 9.52 c -2.66,-24.511 -18.21,-40.191 -41.6,-40.191 -31.51,0 -47.21,24.789 -47.21,52.102 0,27.32 15.7,52.109 47.21,52.109 18.91,0 37.68,-11.34 40.2,-32.359 h -9.53",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1591.34,176.41 c 26.33,0 37.54,22.129 37.54,43.981 0,21.847 -11.21,43.988 -37.54,43.988 -26.48,0 -37.69,-22.141 -37.69,-43.988 0,-21.852 11.21,-43.981 37.69,-43.981 z m 0,96.09 c 31.37,0 47.06,-24.789 47.06,-52.109 0,-27.313 -15.69,-52.102 -47.06,-52.102 -31.53,0 -47.21,24.789 -47.21,52.102 0,27.32 15.68,52.109 47.21,52.109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1660.04,270.391 h 9.52 v -91.879 h 56.04 v -8.133 h -65.56 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1778.75,176.41 c 26.33,0 37.54,22.129 37.54,43.981 0,21.847 -11.21,43.988 -37.54,43.988 -26.47,0 -37.69,-22.141 -37.69,-43.988 0,-21.852 11.22,-43.981 37.69,-43.981 z m 0,96.09 c 31.38,0 47.06,-24.789 47.06,-52.109 0,-27.313 -15.68,-52.102 -47.06,-52.102 -31.52,0 -47.21,24.789 -47.21,52.102 0,27.32 15.69,52.109 47.21,52.109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1856.97,222.91 h 35.58 c 11.63,0 21.57,7.289 21.57,19.481 0,12.179 -7.28,19.879 -21.57,19.879 h -35.58 z m -9.52,47.481 h 45.8 c 16.54,0 30.4,-7.969 30.4,-26.051 0,-12.602 -6.58,-22.969 -19.47,-25.488 v -0.282 c 13.03,-1.679 16.81,-10.648 17.51,-22.55 0.42,-6.872 0.42,-20.598 4.62,-25.641 h -10.51 c -2.37,3.93 -2.37,11.351 -2.66,15.551 -0.84,14.019 -1.96,29.558 -20.02,28.859 h -36.15 v -44.41 h -9.52 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1964.91,209.602 h 39.37 l -19.33,51.269 z m 15.14,60.789 h 10.64 l 39.22,-100.012 h -10.22 l -12.19,31.101 h -45.53 l -12.04,-31.101 h -10.22 l 40.34,100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2055.57,178.512 h 20.31 c 28.71,-0.141 41.18,12.039 41.18,41.879 0,29.839 -12.47,42.031 -41.18,41.879 h -20.31 z m -9.53,91.879 h 34.6 c 30.12,-0.692 45.94,-17.219 45.94,-50 0,-32.782 -15.82,-49.301 -45.94,-50.012 h -34.6 v 100.012",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2190.77,176.41 c 26.33,0 37.54,22.129 37.54,43.981 0,21.847 -11.21,43.988 -37.54,43.988 -26.47,0 -37.68,-22.141 -37.68,-43.988 0,-21.852 11.21,-43.981 37.68,-43.981 z m 0,96.09 c 31.38,0 47.06,-24.789 47.06,-52.109 0,-27.313 -15.68,-52.102 -47.06,-52.102 -31.52,0 -47.21,24.789 -47.21,52.102 0,27.32 15.69,52.109 47.21,52.109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 176.621,41.0508 h 25.906 L 189.922,77.75 h -0.274 z m 2.102,61.3472 H 201.27 L 238.672,2.39063 H 215.84 L 208.27,24.6602 H 170.879 L 163.027,2.39063 H 140.762 L 178.723,102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 255.117,102.398 h 21.848 l 41.746,-67.0894 h 0.273 v 67.0894 h 20.594 V 2.39063 H 317.59 L 275.984,69.3398 h -0.281 V 2.39063 H 255.117 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 381.66,35.5781 c 0,-13.2968 10.36,-18.4883 22.129,-18.4883 7.703,0 19.473,2.25 19.473,12.4688 0,10.793 -14.992,12.6133 -29.699,16.5312 -14.852,3.9219 -29.833,9.6719 -29.833,28.4415 0,20.4375 19.329,30.2497 37.391,30.2497 20.871,0 40.07,-9.1013 40.07,-32.2224 h -21.296 c -0.696,12.0508 -9.243,15.1328 -19.75,15.1328 -7,0 -15.125,-2.9414 -15.125,-11.3398 0,-7.7032 4.753,-8.6914 29.835,-15.1328 7.286,-1.8204 29.696,-6.4375 29.696,-29.1368 C 444.551,13.7305 430.117,0 402.949,0 380.813,0 360.09,10.9297 360.359,35.5781 h 21.301",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 531.199,68.7813 c -1.394,9.9375 -10.918,17.5078 -21.844,17.5078 -19.753,0 -27.175,-16.8008 -27.175,-34.3086 0,-16.6719 7.422,-33.4805 27.175,-33.4805 13.45,0 21.004,9.2383 22.688,22.4102 H 553.34 C 551.094,15.9688 533.867,0 509.355,0 c -30.957,0 -49.167,23.1211 -49.167,51.9805 0,29.6914 18.21,52.8005 49.167,52.8005 21.993,0 40.481,-12.8826 43.145,-35.9997 h -21.301",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 575.266,102.398 h 21.992 V 64.0195 h 40.476 v 38.3785 h 21.993 V 2.39063 H 637.734 V 45.5313 H 597.258 V 2.39063 H 575.266 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 771.438,40.2109 C 771.438,13.1719 755.469,0 728.711,0 701.816,0 686.133,13.0313 686.133,40.2109 v 62.1871 h 21.992 V 40.2109 c 0,-10.9296 2.805,-21.7109 20.586,-21.7109 15.691,0 20.73,6.8594 20.73,21.7109 v 62.1871 h 21.997 V 40.2109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 819.031,83.9102 h -29.976 v 18.4878 h 81.953 V 83.9102 H 841.023 V 2.39063 H 819.031 V 83.9102",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 883.523,19.7617 53.657,64.1485 h -49.453 v 18.4878 h 78.718 V 85.0313 l -53.64,-64.1602 h 55.047 V 2.39063 H 883.523 V 19.7617",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1033.61,102.398 h 30.96 l 23.39,-68.7691 h 0.28 l 22.13,68.7691 h 30.96 V 2.39063 h -20.59 V 73.2695 h -0.28 L 1095.95,2.39063 h -16.96 l -24.51,70.16797 h -0.28 V 2.39063 h -20.59 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1168.25,102.398 h 74.8 V 83.9102 h -52.81 V 62.4688 h 48.47 V 45.3906 h -48.47 V 20.8711 h 53.93 V 2.39063 h -75.92 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1289.23,20.8711 h 19.61 c 12.74,0 24.93,7.8477 24.93,29.9805 0,20.1679 -7,33.0586 -28.86,33.0586 h -15.68 z m -21.99,81.5269 h 43.14 c 25.91,0 45.38,-16.2378 45.38,-49.4488 0,-28.9883 -14.84,-50.55857 -45.38,-50.55857 h -43.14 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1378.51,102.398 h 21.99 V 2.39063 h -21.99 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1493.68,68.7813 c -1.39,9.9375 -10.92,17.5078 -21.84,17.5078 -19.76,0 -27.18,-16.8008 -27.18,-34.3086 0,-16.6719 7.42,-33.4805 27.18,-33.4805 13.44,0 21,9.2383 22.68,22.4102 h 21.3 C 1513.57,15.9688 1496.35,0 1471.84,0 c -30.96,0 -49.17,23.1211 -49.17,51.9805 0,29.6914 18.21,52.8005 49.17,52.8005 21.99,0 40.47,-12.8826 43.14,-35.9997 h -21.3",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1560.26,41.0508 h 25.91 L 1573.56,77.75 h -0.27 z m 2.1,61.3472 h 22.55 l 37.4,-100.00737 h -22.83 l -7.57,22.26957 h -37.4 l -7.84,-22.26957 h -22.27 l 37.96,100.00737",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1638.76,102.398 h 21.99 V 20.8711 h 48.74 V 2.39063 h -70.73 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1841.37,68.7813 c -1.4,9.9375 -10.92,17.5078 -21.85,17.5078 -19.75,0 -27.18,-16.8008 -27.18,-34.3086 0,-16.6719 7.43,-33.4805 27.18,-33.4805 13.45,0 21.01,9.2383 22.69,22.4102 h 21.3 C 1861.26,15.9688 1844.03,0 1819.52,0 c -30.96,0 -49.17,23.1211 -49.17,51.9805 0,29.6914 18.21,52.8005 49.17,52.8005 21.99,0 40.48,-12.8826 43.15,-35.9997 h -21.3",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1907.95,41.0508 h 25.91 L 1921.25,77.75 h -0.27 z m 2.1,61.3472 h 22.55 L 1970,2.39063 h -22.83 l -7.57,22.26957 h -37.39 l -7.85,-22.26957 h -22.27 l 37.96,100.00737",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1986.45,102.398 h 30.95 l 23.39,-68.7691 h 0.28 l 22.13,68.7691 h 30.96 V 2.39063 h -20.59 V 73.2695 h -0.28 L 2048.78,2.39063 h -16.95 l -24.52,70.16797 h -0.28 V 2.39063 h -20.58 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2143.08,55.3398 h 17.09 c 10.22,0 19.32,2.2305 19.32,14.9922 0,12.7383 -9.1,14.9883 -19.32,14.9883 h -17.09 z m -22,47.0582 h 45.1 c 24.94,0 34.6,-15.816 34.6,-32.066 0,-16.25 -9.66,-32.082 -34.6,-32.082 h -23.1 V 2.39063 h -22 V 102.398",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2304.83,40.2109 C 2304.83,13.1719 2288.87,0 2262.11,0 c -26.9,0 -42.58,13.0313 -42.58,40.2109 v 62.1871 h 21.99 V 40.2109 c 0,-10.9296 2.81,-21.7109 20.59,-21.7109 15.69,0 20.73,6.8594 20.73,21.7109 v 62.1871 h 21.99 V 40.2109",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2346.05,35.5781 c 0,-13.2968 10.38,-18.4883 22.14,-18.4883 7.71,0 19.48,2.25 19.48,12.4688 0,10.793 -14.99,12.6133 -29.7,16.5312 -14.85,3.9219 -29.84,9.6719 -29.84,28.4415 0,20.4375 19.33,30.2497 37.4,30.2497 20.88,0 40.07,-9.1013 40.07,-32.2224 h -21.3 c -0.7,12.0508 -9.24,15.1328 -19.75,15.1328 -7,0 -15.13,-2.9414 -15.13,-11.3398 0,-7.7032 4.76,-8.6914 29.84,-15.1328 7.28,-1.8204 29.7,-6.4375 29.7,-29.1368 C 2408.96,13.7305 2394.52,0 2367.35,0 c -22.14,0 -42.86,10.9297 -42.58,35.5781 h 21.28",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 885.305,1699.32 v 82.7 l -98.535,98.76 H 445.316 l -98.855,-98.74 v -340.86 l 98.855,-98.68 h 108.438 v -82.93 l 99.652,-98.78 h 288.125 l 99.909,98.69 v 264.06 h 50.85 v 175.78 H 885.305",
    style: {
      fill: "#ccb567",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 782.551,1870.55 92.5,-92.77 v -88.71 h 206.989 v -155.35 h -50.88 v -269.95 l -93.824,-92.73 H 657.59 l -93.582,92.73 v 88.97 H 449.535 l -92.832,92.74 v 332.3 l 92.832,92.77 h 333.016",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 460.152,1378.37 h 129.453 v -103.89 l 78.532,-77.84 h 258.672 l 78.751,77.84 v 284.88 h 50.9 v 104.1 H 900.305 V 1300.63 H 693.684 v 77.74 h 78.203 l 77.578,77.73 v 103.26 H 745.398 v -77.16 h -51.714 v 181.26 H 537.973 v -104.1 h 51.632 V 1482.2 H 486.137 v 259.64 h 259.261 v -78.38 h 104.067 v 103.7 l -77.578,77.78 H 460.152 L 382.27,1767.18 V 1456.1 l 77.882,-77.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 680.852,1391.18 h 85.742 l 70.054,70.18 v 85.19 H 758.23 v -77.14 h -77.378 v 181.22 H 550.766 v -78.49 h 51.66 V 1469.41 H 473.363 v 285.21 H 758.23 v -78.36 h 78.418 v 85.62 l -70.054,70.26 H 465.453 l -70.359,-70.26 v -300.52 l 70.332,-70.18 h 137 v -111.37 l 71.004,-70.39 h 248.101 l 71.235,70.45 v 292.27 h 50.854 v 78.49 H 913.113 V 1287.86 H 680.852 v 103.32",
    style: {
      fill: "#ccb567",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1282.48,1917.55 V 1135.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1282.48,1917.55 V 1135.09",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2081.35,1521.85 c 0,0 -4.86,1.54 -12.34,0.61 v 0 0 c -1.27,-18.35 5.34,-38.77 5.34,-38.77 0,0 0.35,-1.19 1,-3.31 l 1.27,-4.22 c 38.95,-11.62 94.44,-28.62 94.44,-28.62 0,0 6.7,-2.08 15.83,-3.68 3.57,14.37 6.26,28.92 8.04,43.58 -44.96,13.36 -107.6,32.76 -113.58,34.41 z m 5.46,-78.9 h -0.07 c 9.42,-31.06 21.44,-70.93 25.45,-85.39 0,0 4.26,-13.58 -5.97,-30.43 0,0 -20.39,-35.55 -47.44,-28.86 -1.64,0.4 -3.69,0.94 -6.07,1.6 0.15,-0.49 0.28,-0.98 0.41,-1.39 0,0 4.23,-13.58 -5.95,-30.43 0,0 0,0 0.02,0.02 0,0 -20.46,-35.59 -47.51,-28.89 -13.39,3.31 -53.91,15.5 -90.22,26.53 v 0 c 0.02,0 0.02,0 0.02,0 8.68,-28.64 19.61,-64.83 24.4,-81.62 57.96,16.03 112.67,46.81 158.24,92.37 40.65,40.63 69.54,88.58 86.68,139.6 -0.6,0.11 -1.27,0.22 -1.84,0.37 -13.41,3.32 -53.89,15.49 -90.15,26.52 z m 5.31,342.59 c -5.99,5.98 -12.13,11.7 -18.41,17.18 8.5,-28 19.36,-63.8 28.29,-93.74 9.51,-2.91 15.28,-4.66 15.28,-4.66 0,0 18.63,-5.86 40.05,-7.8 -16.59,32.04 -38.33,62.13 -65.21,89.02 z m -76.4,58.36 c -54.05,30.83 -114.4,46.51 -174.85,47.06 9.07,-29.83 19.9,-65.82 23.61,-79.24 0,0 4.31,-13.47 -5.77,-30.25 0,0 -20.41,-35.57 -47.46,-28.87 -1.69,0.4 -3.8,0.97 -6.29,1.65 v 0 c 0.15,-0.55 0.32,-1.12 0.43,-1.61 0,0 4.25,-13.57 -5.95,-30.42 h 0.02 c 0,0 -20.41,-35.55 -47.46,-28.86 -13.41,3.3 -53.94,15.49 -90.22,26.52 9.42,-31.1 21.44,-70.95 25.45,-85.42 0,0 4.23,-13.58 -5.97,-30.4 0,0 0.02,0 0.04,0 0,0 -20.41,-35.57 -47.48,-28.88 -1.63,0.41 -3.67,0.94 -6.06,1.6 0.13,-0.47 0.28,-0.98 0.38,-1.39 0,0 2.68,-8.59 -1.34,-20.54 -2.24,-6.88 -6.03,-12.95 -10.25,-18.05 -4.62,-5.91 -11.81,-13.56 -20.71,-17.99 -0.02,0 -0.02,0 -0.02,0 v 0 c -6.28,-3.12 -13.43,-4.62 -21.08,-2.72 -14.24,3.52 -59.02,17.02 -96.84,28.55 -2.03,-53.78 7.92,-107.95 29.89,-158.11 25.6,17.92 47.25,13.39 50.9,12.42 -0.11,0.04 -0.08,0.01 -0.17,0.06 -0.67,2.28 -1.24,4.35 -1.77,6.13 -3.8,13.81 0.84,26.97 8.33,38.21 -0.04,-0.04 -0.1,-0.06 -0.15,-0.08 3.57,5.31 7.78,10.22 12.06,14.54 l 8.33,8.29 c 33.57,33.59 65.01,23.55 65.01,23.55 21.8,-6.03 81.11,-23.91 128.49,-38.29 l -5.15,17.1 c -15.03,49.93 -30.11,100.45 -35.11,118.48 -3.81,13.79 0.81,26.95 8.29,38.18 -0.06,-0.04 -0.08,-0.06 -0.15,-0.08 3.59,5.34 7.83,10.25 12.11,14.55 l 8.28,8.32 c 31.59,31.57 60.92,24.65 64.34,23.7 -0.11,0.05 -0.09,0.05 -0.24,0.07 -0.67,2.34 -1.26,4.4 -1.73,6.13 -3.83,13.88 0.83,27.1 8.4,38.38 -0.03,-0.02 -0.03,-0.02 -0.03,-0.02 3.61,5.35 7.82,10.24 12.09,14.55 l 8.3,8.3 c 33.59,33.59 65.03,23.56 65.03,23.56 21.76,-6.03 80.81,-23.83 128.13,-38.19 -13.2,43.92 -27.64,92.02 -35.66,119.51 z m -174.05,-54.99 c -1.49,5.44 -17.37,57.86 -30.32,101.13 -15.16,-1.13 -30.28,-3.19 -45.23,-6.21 0.72,-2.74 1.42,-5.08 1.42,-5.08 0,0 16.29,-53.24 27.87,-92.01 6.18,-1.9 9.91,-3.04 9.91,-3.04 0,0 18.91,-5.94 36.71,-5.4 0.34,1.25 0.5,2.52 0.55,3.76 -0.08,4.28 -0.91,6.85 -0.91,6.85 z m -345.58,-143.86 c 3.58,-0.21 5.71,-0.89 5.71,-0.89 14.17,-3.92 52.74,-15.54 83.52,-24.88 -10.77,35.78 -22.56,75.06 -26.16,88.12 -1.4,5.04 -1.06,9.93 0.35,14.54 v -0.02 c 0,0.05 0.03,0.06 0.03,0.09 v 0 c 0.69,2.47 1.83,4.91 3.18,7.23 0.57,1.03 1.89,3.03 1.92,3.06 4.36,6.41 9.57,11.24 9.57,11.24 l 3.5,3.5 c 19.63,19.62 38.14,16.32 41.67,15.45 -0.43,1.52 -0.83,2.87 -1.15,4.01 -2.48,9 0.55,17.6 5.47,24.92 v 0 c 2.32,3.46 5.05,6.64 7.86,9.44 l 5.38,5.41 c 21.86,21.84 42.27,15.32 42.27,15.32 14.15,-3.92 52.55,-15.5 83.29,-24.84 -1.82,6.03 -19.74,65.89 -23.94,80.4 -56.94,-16.24 -110.67,-46.76 -155.52,-91.61 -40.88,-40.89 -69.85,-89.15 -86.95,-140.49 z m 674.47,22.98 c -12.13,-9.24 -27.31,-15.77 -44.22,-11.6 -2.57,0.66 -5.84,1.52 -9.66,2.55 v -0.02 c 0.23,-0.84 0.49,-1.68 0.69,-2.44 0,0 6.65,-20.88 -9.04,-46.75 0,0 -2.24,-0.95 -0.08,-0.04 0,0 -31.44,-54.69 -73.04,-44.41 -20.62,5.09 -82.97,23.83 -138.8,40.83 v -0.02 0 c 0.63,-2.11 1.29,-4.22 1.94,-6.38 l 0.08,-0.31 v 0 c 14.17,-46.7 31.27,-103.48 37.16,-124.71 0,0 6.64,-20.86 -9.03,-46.75 l -0.1,-0.04 c -0.09,-0.13 -31.47,-54.72 -73.02,-44.41 -2.51,0.61 -5.68,1.45 -9.34,2.45 v -0.02 c 0.21,-0.74 0.4,-1.46 0.61,-2.13 0,0 6.62,-20.86 -9.07,-46.72 l -0.06,-0.05 c 0,0 -31.42,-54.71 -73.06,-44.42 -20.62,5.1 -82.97,23.84 -138.8,40.82 v -0.03 h 0.02 c 7.42,-24.48 15.89,-52.5 23.21,-77 v 0 c 0,0 8.08,-27.09 11.12,-37.53 v -0.02 c 53.49,-30.83 113.22,-46.75 173.14,-47.8 -10.22,34.03 -20.93,69.83 -24.35,82.15 -2.45,8.98 0.51,17.52 5.4,24.82 -0.04,-0.03 -0.07,-0.05 -0.11,-0.07 2.32,3.5 5.09,6.66 7.86,9.47 l 5.41,5.4 c 19.62,19.65 38.13,16.34 41.66,15.47 -0.44,1.52 -0.82,2.85 -1.14,3.99 -2.49,8.98 0.54,17.54 5.42,24.84 2.34,3.48 4.98,6.59 7.74,9.38 l 5.39,5.42 c 21.85,21.82 42.26,15.28 42.26,15.28 14.17,-3.92 52.75,-15.54 83.53,-24.88 l -1.11,3.76 c -10.48,34.75 -21.57,71.77 -25.05,84.38 -2.47,8.96 0.53,17.5 5.38,24.82 -0.03,-0.03 -0.07,-0.05 -0.09,-0.07 2.35,3.48 5.08,6.66 7.85,9.47 l 5.4,5.42 c 19.64,19.6 38.14,16.32 41.66,15.46 -0.42,1.51 -0.8,2.86 -1.12,3.98 -2.49,9.02 0.55,17.63 5.48,24.94 0.34,0.24 0.68,0.45 1.02,0.67 -0.34,-0.22 -0.71,-0.43 -1.06,-0.69 2.34,3.48 5.08,6.66 7.86,9.47 l 5.4,5.4 c 21.82,21.82 42.26,15.28 42.26,15.28 15.68,-4.32 61.27,-18.11 93.11,-27.78 2,51.29 -6.9,102.95 -26.71,151.17 z M 1876.69,1275.7 c -16.9,5.17 -29.35,8.96 -31.84,9.66 0,0 -4.8,1.52 -12.2,0.61 -1.2,-18.32 5.33,-38.63 5.33,-38.63 0,0 12.19,-39.78 22.97,-75.56 15.13,0.99 30.25,2.91 45.2,5.79 -7.44,24.7 -20.11,66.68 -29.46,98.13 z m -276.73,-15.11 -0.03,0.02 c 0,0.02 -0.02,0.02 -0.02,0.02 -0.29,1.01 -0.61,2.02 -0.91,3.04 l -0.02,0.02 v 0 c -7.88,26.02 -17.45,57.62 -25.7,85.14 0.02,0 0.02,-0.03 0.02,-0.03 l 0.03,0.03 c -26.03,7.92 -45.15,13.79 -48.98,14.84 0,0 -2.24,0.72 -6.16,1.12 16.55,-31.8 38.16,-61.63 64.85,-88.33 5.5,-5.5 11.13,-10.79 16.92,-15.87 z m 303.98,83.83 c 0,0 -4.79,1.54 -12.21,0.63 -1.2,-18.3 5.33,-38.62 5.33,-38.62 0,0 0.87,-2.81 2.3,-7.54 38.92,-11.61 94.44,-28.6 94.44,-28.6 0,0 18.95,-5.97 36.8,-5.4 0.4,1.5 0.58,3.04 0.58,4.57 -0.14,3.88 -0.89,6.2 -0.89,6.2 -0.69,2.57 -4.67,15.77 -10.03,33.55 -45.1,13.39 -110.23,33.54 -116.32,35.21 z m 148.96,-15.04 c 0,0 18.96,-5.98 36.77,-5.41 0.36,1.41 0.59,2.93 0.63,4.34 -0.16,4.03 -0.91,6.43 -0.91,6.43 -1.68,6.01 -20.95,69.62 -34.4,114.62 v 0 0.04 c -0.36,1.21 -0.72,2.38 -1.05,3.56 v 0 0 c -16.9,5.17 -29.31,8.97 -31.82,9.66 0,0 -4.8,1.52 -12.22,0.61 -1.22,-18.32 5.32,-38.64 5.32,-38.64 0,0 16.36,-53.46 27.96,-92.25 6.07,-1.86 9.72,-2.96 9.72,-2.96 z m 29.38,292.05 c -1.04,3.86 -6.84,23.07 -14.68,49.18 l -0.87,2.8 c -69.35,20.58 -169.2,51.49 -178.57,54.08 0,0 -7.56,2.24 -19.02,0.82 -1.91,-28.21 8.18,-59.56 8.18,-59.56 0,0 1.31,-4.27 3.57,-11.56 59.9,-17.9 145.25,-44 145.25,-44 0,0 29.71,-9.36 57.38,-8.29 l -0.02,0.17 c 0.8,10.02 -1.22,16.36 -1.22,16.36 z m -602.09,-47.36 c 38.42,-11.48 88.64,-26.86 88.64,-26.86 0,0 18.96,-5.96 36.8,-5.41 0.42,1.52 0.59,3.05 0.59,4.57 -0.15,3.9 -0.89,6.2 -0.89,6.2 -0.72,2.59 -4.68,15.79 -10.01,33.57 -36.5,10.83 -86.1,26.07 -106.95,32.4 -3.66,-14.67 -6.39,-29.51 -8.18,-44.47 z m 116.96,165.46 c 0,0 -4.74,1.62 -12.23,0.61 -0.06,-1.1 -0.13,-3.5 -0.13,-3.58 -0.25,-17.27 5.46,-35.03 5.46,-35.03 0,0 16.35,-53.64 27.9,-92.24 6.12,-1.88 9.78,-3 9.78,-3 0,0 18.92,-5.97 36.73,-5.39 0.72,2.59 0.64,5.37 0.45,7.12 -0.09,0.7 -0.17,1.31 -0.28,1.82 v 0 c -0.21,1.18 -0.4,1.81 -0.4,1.81 -1.71,6.2 -22.01,73.1 -35.47,118.22 1.15,-0.33 -29.13,8.92 -31.81,9.66 z m 186.2,-14.1 c -0.25,2.8 -0.74,4.4 -0.74,4.4 -0.44,1.58 -2.11,7.13 -4.55,15.27 l -5.57,18.53 c -45.1,13.37 -110,33.46 -116.11,35.12 0,0 -4.79,1.53 -12.21,0.64 -0.08,-0.55 -0.17,-1.09 -0.21,-1.67 -0.32,-7.13 0.46,-14.46 1.54,-20.7 1.22,-6.58 2.84,-12.84 4.13,-17.31 0.36,-1.18 1.07,-3.48 2.03,-6.64 38.92,-11.62 94.43,-28.59 94.43,-28.59 0,0 18.98,-6 36.8,-5.42 v 0 0 c 0.08,0.27 0.14,0.57 0.21,0.84 0.4,1.96 0.38,3.99 0.25,5.53 z m 26.25,-376.69 c -0.95,3.37 -5.48,18.53 -11.87,39.77 l -3.58,11.89 c -69.37,20.58 -169.55,51.57 -178.91,54.17 0,0 -7.46,2.19 -18.8,0.86 -1.84,-28.17 8.19,-59.35 8.19,-59.35 0,0 1.31,-4.3 3.55,-11.58 59.9,-17.86 145.29,-44 145.29,-44 0,0 29.71,-9.34 57.36,-8.27 l -0.03,0.15 c 0.83,10.02 -1.2,16.36 -1.2,16.36 z m 39.6,261.83 c 20.56,-68.8 48.79,-161.91 51.28,-170.93 0,0 2.04,-6.32 1.22,-16.37 l 0.02,-0.14 c -27.64,-1.1 -57.35,8.26 -57.35,8.26 0,0 -5.63,1.71 -14.95,4.58 -17.81,59.67 -42.99,141.9 -42.99,141.9 0,0 -10.04,31.16 -8.22,59.34 11.36,1.36 18.83,-0.85 18.83,-0.85 3.83,-1.07 22.97,-6.92 48.98,-14.86 l 0.02,-0.03 c -0.04,0.03 -0.07,0.03 -0.07,0.03 1.04,-3.57 2.13,-7.21 3.23,-10.93 v 0",
    style: {
      fill: "#28497e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2015.22,1424.59 c 0,0 -6.54,20.34 -5.32,38.64 -5.6,-0.67 -12.7,-2.74 -20.38,-7.91 -4.87,-7.29 -7.89,-15.85 -5.4,-24.83 3.6,-13.07 15.39,-52.34 26.16,-88.12 13.26,-4.05 25.12,-7.63 32.9,-10.03 -11.6,38.79 -27.96,92.25 -27.96,92.25",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2044.32,1485.59 c 0.4,-0.09 0.61,-0.18 0.61,-0.18 6.48,-1.79 18.07,-5.21 31.69,-9.25 -1.43,4.7 -2.27,7.53 -2.27,7.53 0,0 -6.61,20.41 -5.34,38.75 -5.61,-0.7 -12.69,-2.76 -20.33,-7.95 -4.93,-7.29 -7.97,-15.9 -5.48,-24.92 0.32,-1.12 0.7,-2.47 1.12,-3.98",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2047.17,1268.07 c -0.02,-0.02 -0.02,-0.02 -0.02,-0.02 -0.11,-0.19 0.02,0.02 0.02,0.02",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2053.12,1298.48 c -0.13,0.4 -0.26,0.9 -0.43,1.39 -7.76,2.11 -19.25,5.45 -32.43,9.36 5.36,-17.78 9.32,-30.97 10.03,-33.57 0,0 0.75,-2.3 0.89,-6.2 0,-1.52 -0.18,-3.07 -0.61,-4.55 5.89,0.17 11.66,1.09 16.58,3.14 10.2,16.85 5.97,30.43 5.97,30.43",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1832.65,1286 c -5.61,-0.7 -12.7,-2.75 -20.37,-7.91 -4.89,-7.32 -7.87,-15.86 -5.4,-24.86 3.42,-12.32 14.11,-48.05 24.33,-82.13 9.93,-0.19 19.83,0.07 29.71,0.7 -10.77,35.82 -22.94,75.54 -22.94,75.54 0,0 -6.53,20.33 -5.33,38.66",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2112.19,1357.56 c -4.03,14.46 -16.03,54.33 -25.47,85.39 -11.72,3.58 -23,7 -32.8,10.01 13.46,-45.12 33.75,-112.04 35.46,-118.22 0,0 0.76,-2.4 0.9,-6.4 -0.02,-1.44 -0.23,-2.94 -0.58,-4.35 5.86,0.16 11.61,1.07 16.52,3.14 10.21,16.85 5.97,30.43 5.97,30.43",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2105.87,1326.52 c 0.22,0.38 0.37,0.61 0.37,0.61 h -0.02 c -0.13,-0.19 -0.23,-0.4 -0.35,-0.61",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1876.69,1275.73 c 9.35,-31.46 22.02,-73.44 29.46,-98.13 9.32,1.79 18.56,3.98 27.73,6.51 -4.77,16.75 -15.69,52.93 -24.4,81.6 -11.75,3.56 -23.02,7.02 -32.79,10.02",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1897.06,1306.43 c 0,0 -6.53,20.32 -5.31,38.64 -5.61,-0.67 -12.72,-2.74 -20.39,-7.9 -4.88,-7.32 -7.88,-15.86 -5.42,-24.86 0.32,-1.12 0.72,-2.47 1.16,-3.99 0.36,-0.1 0.59,-0.15 0.59,-0.15 6.47,-1.81 18.07,-5.2 31.67,-9.28 -1.43,4.73 -2.3,7.54 -2.3,7.54",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2171.04,1447.54 c 0,0 -101.11,30.94 -126.11,37.87 0,0 -20.45,6.52 -42.27,-15.28 l -5.4,-5.42 c -2.77,-2.81 -5.5,-5.99 -7.85,-9.47 v 0 c 17.88,12.08 32.71,7.38 32.71,7.38 8.43,-2.36 129.61,-39.96 154.82,-46.19 0.61,-0.18 1.22,-0.26 1.84,-0.37 3.08,9.18 5.77,18.46 8.1,27.78 -9.16,1.6 -15.84,3.7 -15.84,3.7 z m -64.8,-120.41 c -19.81,-8.35 -53.34,2.25 -53.34,2.25 0,0 -101.12,30.94 -126.15,37.87 0,0 -20.41,6.54 -42.26,-15.3 l -5.39,-5.4 c -2.76,-2.81 -5.53,-5.99 -7.87,-9.46 v 0 c 17.88,12.07 32.71,7.35 32.71,7.35 8.43,-2.34 129.62,-39.93 154.82,-46.17 27.05,-6.69 47.48,28.86 47.48,28.86 z m -106.56,-87.95 c 27.05,-6.68 47.49,28.89 47.49,28.89 -19.81,-8.37 -53.37,2.22 -53.37,2.22 0,0 -101.1,30.95 -126.11,37.88 0,0 -20.45,6.54 -42.26,-15.31 l -5.39,-5.39 c -2.78,-2.83 -5.55,-5.99 -7.87,-9.47 v 0 c 17.86,12.11 32.68,7.38 32.68,7.38 8.46,-2.36 129.63,-39.98 154.83,-46.2 z m 197.57,277.68 c -0.38,-9.81 -1.17,-19.64 -2.35,-29.44 -44.93,13.38 -107.57,32.76 -113.55,34.43 0,0 -14.81,4.72 -32.71,-7.36 v 0 c 2.34,3.46 5.08,6.66 7.86,9.47 l 5.4,5.4 c 21.8,21.82 42.26,15.28 42.26,15.28 15.68,-4.34 61.25,-18.11 93.09,-27.78",
    style: {
      fill: "#8da6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1926.46,1427.96 c -30.47,-12.86 -82.09,3.43 -82.09,3.43 0,0 -155.52,47.59 -194.02,58.26 0,0 -31.44,10.04 -65.01,-23.55 l -8.33,-8.29 c -4.28,-4.32 -8.49,-9.23 -12.05,-14.54 v 0 c 27.49,18.57 50.28,11.3 50.28,11.3 12.97,-3.59 199.4,-61.44 238.2,-71.04 41.62,-10.31 73.02,44.43 73.02,44.43",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1753.5,1340.5 c 0,0 -155.53,47.61 -194.05,58.25 0,0 -23.53,7.52 -51.62,-12.22 3.19,-7.34 6.65,-14.6 10.38,-21.72 3.92,-0.42 6.16,-1.14 6.16,-1.14 12.96,-3.58 199.39,-61.42 238.17,-71.03 41.62,-10.29 73.04,44.42 73.04,44.42 -30.47,-12.84 -82.08,3.44 -82.08,3.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2026.14,1613.17 c 0,0 -155.5,47.59 -194.04,58.26 0,0 -31.4,10.03 -65.01,-23.54 l -8.26,-8.32 c -4.3,-4.31 -8.52,-9.22 -12.11,-14.55 v 0 c 27.52,18.62 50.32,11.32 50.32,11.32 12.96,-3.58 199.38,-61.44 238.17,-71.03 41.6,-10.29 73.04,44.4 73.04,44.4 -30.5,-12.82 -82.11,3.46 -82.11,3.46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2157.31,1696.52 c -21.44,1.94 -40.03,7.78 -40.03,7.78 0,0 -155.53,47.58 -194.03,58.25 0,0 -31.44,10.04 -65.01,-23.53 l -8.32,-8.3 c -4.24,-4.33 -8.48,-9.22 -12.09,-14.57 v 0 c 27.52,18.59 50.33,11.32 50.33,11.32 12.97,-3.58 199.38,-61.44 238.18,-71.04 16.89,-4.17 32.09,2.34 44.2,11.58 -4,9.63 -8.38,19.14 -13.23,28.51",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1631.58,1800.84 c -2.8,-2.8 -5.54,-5.98 -7.86,-9.44 v 0 c 17.86,12.08 32.68,7.33 32.68,7.33 8.45,-2.32 129.63,-39.93 154.85,-46.15 27.05,-6.7 47.48,28.87 47.48,28.87 -19.8,-8.36 -53.39,2.23 -53.39,2.23 0,0 -101.08,30.93 -126.11,37.89 0,0 -20.43,6.52 -42.27,-15.33 l -5.38,-5.4",
    style: {
      fill: "#8da6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1572.33,1741.61 c -2.78,-2.82 -5.52,-5.96 -7.86,-9.46 v 0 c 17.88,12.1 32.7,7.36 32.7,7.36 8.44,-2.32 129.61,-39.94 154.83,-46.17 27.05,-6.69 47.48,28.88 47.48,28.88 -19.8,-8.35 -53.37,2.23 -53.37,2.23 0,0 -101.1,30.94 -126.12,37.87 0,0 -20.43,6.54 -42.26,-15.3 l -5.4,-5.41",
    style: {
      fill: "#8da6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1622.22,1544.96 c -19.78,-8.35 -53.37,2.25 -53.37,2.25 0,0 -50.22,15.38 -88.64,26.86 -1.18,-9.78 -1.91,-19.6 -2.29,-29.45 37.84,-11.51 82.63,-25.03 96.84,-28.53 27.05,-6.7 47.46,28.87 47.46,28.87",
    style: {
      fill: "#8da6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1633.84,1575.18 c 27.05,-6.69 47.48,28.88 47.48,28.88 -19.82,-8.37 -53.37,2.21 -53.37,2.21 0,0 -101.09,30.96 -126.1,37.87 0,0 -2.15,0.7 -5.74,0.89 -2.91,-8.75 -5.48,-17.59 -7.72,-26.49 30.7,-9.32 123.73,-37.99 145.45,-43.36",
    style: {
      fill: "#8da6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1811.35,1889.99 c 12.95,-43.27 28.83,-95.66 30.34,-101.1 0,0 0.81,-2.57 0.89,-6.85 -0.05,-1.24 -0.21,-2.52 -0.55,-3.78 5.92,0.19 11.74,1.1 16.7,3.19 10.06,16.78 5.75,30.25 5.75,30.25 -3.73,13.52 -14.48,49.21 -23.57,79.22 -9.87,0.08 -19.71,-0.23 -29.56,-0.93",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1762.52,1796.73 c 13.24,-4.03 25.05,-7.63 32.89,-10.01 -11.55,38.77 -27.87,92.01 -27.87,92.01 0,0 -0.62,1.92 -1.42,5.06 -9.25,-1.85 -18.44,-4.09 -27.53,-6.68 4.95,-17.19 14.8,-50.02 23.93,-80.38",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1799.12,1721.61 c 0.21,0.37 0.36,0.61 0.36,0.61 l -0.02,-0.02 c -0.1,-0.19 -0.19,-0.36 -0.34,-0.59",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1805.41,1752.62 c -0.13,0.49 -0.3,1.06 -0.42,1.6 -7.83,2.14 -19.3,5.47 -32.48,9.39 5.38,-17.9 9.38,-31.21 10.1,-33.78 0,0 0.76,-2.49 0.89,-6.6 -0.02,-1.37 -0.21,-2.83 -0.61,-4.17 5.88,0.16 11.64,1.07 16.57,3.14 10.18,16.84 5.95,30.42 5.95,30.42",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1590.28,1701.51 c 0,0 -6.52,20.31 -5.32,38.61 -5.6,-0.67 -12.69,-2.72 -20.37,-7.89 -4.89,-7.29 -7.88,-15.87 -5.42,-24.83 3.61,-13.08 15.42,-52.36 26.17,-88.14 13.29,-4.03 25.11,-7.63 32.89,-10.01 -11.57,38.79 -27.95,92.26 -27.95,92.26",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1628.16,1575.36 c -0.1,0.44 -0.24,0.95 -0.37,1.39 -7.79,2.13 -19.27,5.44 -32.45,9.39 5.33,-17.8 9.29,-30.98 10.01,-33.57 0,0 0.74,-2.32 0.89,-6.22 0,-1.5 -0.17,-3.06 -0.61,-4.55 5.9,0.18 11.66,1.09 16.57,3.16 10.2,16.83 5.96,30.4 5.96,30.4",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1661.8,1719.88 c -11.75,3.54 -23.03,7 -32.81,9.97 13.45,-45.1 33.75,-112.03 35.46,-118.2 0,0 0.76,-2.4 0.89,-6.41 0,-1.46 -0.21,-2.93 -0.61,-4.36 5.88,0.18 11.64,1.09 16.55,3.16 10.2,16.82 5.97,30.4 5.97,30.4 -4.01,14.49 -16.03,54.34 -25.45,85.44",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1649.38,1760.59 c 0,0 -6.58,20.39 -5.32,38.75 -5.6,-0.69 -12.67,-2.75 -20.32,-7.94 -4.94,-7.32 -7.97,-15.92 -5.48,-24.93 0.31,-1.13 0.71,-2.48 1.13,-4 0.39,-0.08 0.6,-0.15 0.6,-0.15 6.47,-1.79 18.09,-5.21 31.68,-9.27 -1.43,4.74 -2.29,7.54 -2.29,7.54",
    style: {
      fill: "#3a7aab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1829.46,1677.79 c 0.49,-1.73 1.06,-3.79 1.75,-6.11 0.57,-0.17 0.89,-0.25 0.89,-0.25 9.99,-2.77 27.81,-8.02 48.79,-14.28 -2.26,7.32 -3.57,11.6 -3.57,11.6 0,0 -10.11,31.41 -8.18,59.65 -8.62,-1.08 -19.52,-4.29 -31.28,-12.23 -7.55,-11.26 -12.23,-24.48 -8.4,-38.38",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1901.72,1423.11 c 8.8,0.34 17.37,1.73 24.74,4.83 l 0.1,0.04 c 15.67,25.89 9.03,46.75 9.03,46.75 -6.17,22.24 -24.65,83.57 -39.18,131.37 -18.03,5.49 -35.4,10.8 -50.46,15.37 20.69,-69.38 51.91,-172.32 54.55,-181.83 0,0 2.02,-6.32 1.2,-16.37 l 0.02,-0.16",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1558.54,1399.01 c 0.57,-0.17 0.91,-0.26 0.91,-0.26 9.95,-2.76 27.81,-8.01 48.75,-14.27 -2.24,7.3 -3.54,11.6 -3.54,11.6 0,0 -10.08,31.24 -8.19,59.44 -8.64,-1.04 -19.56,-4.22 -31.37,-12.17 -7.48,-11.24 -12.12,-24.4 -8.31,-38.21 0.51,-1.78 1.1,-3.85 1.75,-6.13",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1746.88,1625.14 c -7.51,-11.23 -12.13,-24.41 -8.29,-38.2 5.54,-20.12 23.66,-80.55 40.23,-135.6 20.45,-6.2 38.63,-11.72 50.6,-15.39 -17.79,59.65 -42.97,141.9 -42.97,141.9 0,0 -10.08,31.27 -8.22,59.44 -8.61,-1.06 -19.53,-4.22 -31.35,-12.15",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1658.09,1218.9 c -8.31,28.55 -22.61,75.95 -34.33,114.53 -18.03,5.48 -35.4,10.78 -50.46,15.42 8.58,-28.62 18.58,-61.64 26.63,-88.2 18.28,-16.04 37.77,-29.98 58.16,-41.75",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1844.71,1383.83 c -0.21,0.67 -0.4,1.39 -0.59,2.13 -11.98,3.26 -29.65,8.39 -49.93,14.42 8.2,-27.35 14.32,-47.65 15.43,-51.64 0,0 2.03,-6.34 1.21,-16.36 l 0.01,-0.15 c 8.77,0.32 17.38,1.71 24.7,4.83 l 0.1,0.05 c 15.69,25.86 9.07,46.72 9.07,46.72",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2108.31,1609.75 c 15.68,25.89 9.04,46.75 9.04,46.75 -0.2,0.75 -0.46,1.62 -0.67,2.45 -12.06,3.3 -29.67,8.43 -49.95,14.44 8.29,-27.54 14.46,-48 15.55,-51.98 0,0 2.02,-6.35 1.22,-16.34 l 0.02,-0.19 c 8.77,0.34 17.35,1.73 24.7,4.83 l 0.09,0.04",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2073.69,1802.68 c -18.22,15.86 -37.62,29.56 -57.94,41.16 7.95,-27.33 22.29,-75.11 35.63,-119.49 20.37,-6.18 38.54,-11.72 50.62,-15.42 -8.97,30.05 -19.79,65.73 -28.31,93.75",
    style: {
      fill: "#bdbcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path244"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLindaLogo);
export default __webpack_public_path__ + "static/media/linda-logo.257dcd348adb4d9352430cd03a3e8b35.svg";
export { ForwardRef as ReactComponent };